import ModalTypeProps from "./";
import AddManager from "./userPermissionPopup/addManager";
import { ConfirmationModal } from "./confirmation/confirm";
import AddGroupsModal from "./addFranchisePopup/addGroupPopup";
import { RedirectConfirmationModal } from "./confirmation/redirectConfirmation";
import ResetPasswordUserPermission from "./userPermissionPopup/resetPasswordUserPermission";
import MarketingAttributionReportBody from "./marketingAttribution/marketingAttributionReportBody";
import ConversationAllInternalNotesModal from "./consumerResponsesPopup/ConversationAllInternalNotesModal";
import PreviewImageModal from "./inboxPopups/previewImageModal";
import UpdateGoogleSocialLinkModal from "./featureFlags/updateGoogleSocialLinkModal";
import UpdateFeatureFlagsModal from "./featureFlags/updateFeatureFlagsModal";
import UpdateBrandSocialLinkModal from "./featureFlags/updateBrandSocialLinkModal";
import { PrivacyPolicyConfirmationModal } from "./confirmation/confirmPrivacyPolicyPopup";

//Method for exporting UserPermissions Modals
export const getConfirmationModal = (props = {}) => (
  <ConfirmationModal {...ModalTypeProps.ConfirmationModal} {...props} />
);

export const resetPasswordUserPermission = (props = {}) => (
  <ResetPasswordUserPermission
    {...ModalTypeProps.resetPasswordUserPermissionModal}
    {...props}
  />
);

export const getSurveyPreviewModal = (props = {}) => (
  <RedirectConfirmationModal
    {...ModalTypeProps.PreviewSurveyModal}
    {...props}
  />
);

export const addFranchisePreviewModal = (props = {}) => (
  <AddGroupsModal {...ModalTypeProps.AddGroupsModal} {...props} />
);
export const addManagerPreviewModal = (props = {}) => (
  <AddManager {...ModalTypeProps.AddManagerModal} {...props} />
);

export const archiveQuestionConfirmationModal = (props = {}) => (
  <ConfirmationModal
    {...ModalTypeProps.archiveQuestionConfirmationModal}
    {...props}
  />
);

export const openConversationAllInternalNotesModal = (props = {}) => (
  <ConversationAllInternalNotesModal
    {...ModalTypeProps.allConversationsModal}
    {...props}
  />
);

export const getMarketingAttributionReportBodyModal = (props = {}) => (
  <MarketingAttributionReportBody
    {...ModalTypeProps.marketingAttributionReportBodyModal}
    {...props}
  />
);

export const getPreviewImageModal = (props = {}) => (
  <PreviewImageModal {...props} />
);

export const updateGoogleSocialLinkModal = (props = {}) => (
  <UpdateGoogleSocialLinkModal
    {...ModalTypeProps.FeatureFlagsModal}
    {...props}
  />
);

export const updateFeatureFlagsPopup = (props = {}) => (
  <UpdateFeatureFlagsModal {...ModalTypeProps.FeatureFlagsModal} {...props} />
);

export const updateBrandPopup = (props = {}) => (
  <UpdateBrandSocialLinkModal
    {...ModalTypeProps.FeatureFlagsModal}
    {...props}
  />
);

export const getPrivacyPolicyConfirmationModal = (props = {}) => (
  <PrivacyPolicyConfirmationModal {...props} />
);
